<template>
  <div>
    <div v-if="show">
      <NoticeBar />
      <div class="agency-top">
        <img src="../../assets/images/bg_02.jpg" class="img" />
        <div class="agency-t-m">
          <div class="agency-t-m-1"><img :src="this.$store.state.avatar" /></div>
          <div class="agency-t-m-2">
            <p class="u-name">{{ userInfo.username }}</p>
            <span class="u-phone" v-if="this.$store.state.phone != '' && this.$store.state.phone != null">{{ this.$store.state.phone }}</span>
            <router-link to="/users/binding" v-else><span class="u-phone">绑定手机号</span></router-link>
          </div>
        </div>
      </div>
      <div class="retails-w">
        <span>今天有 {{ user.orders_count }} 人购买了您的商品</span>
      </div>
      <div class="retails-shop">
        <div class="retails-s-li" @click="showShare = true">
          <span>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-4"></use>
            </svg>
          </span>
          <p>推广宣传</p>
        </div>
        <div class="retails-s-li">
          <router-link to="/retails/share">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-lingshouguanliretail"></use>
              </svg>
            </span>
            <p>推广商品</p>
          </router-link>
        </div>
      </div>
      <div class="retails-tab">
        <van-tabs v-model="active">
          <van-tab title="本月">
            <div class="left retails-t-li">
              <div class="left r-li-l">
                <span>{{ user.month_price }}</span>
                <p>推广销售额</p>
              </div>
              <div class="right r-li-r">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-tongji"></use>
                </svg>
              </div>
            </div>
            <div class="right retails-t-li">
              <div class="left r-li-l">
                <span>{{ user.month_count }}</span>
                <p>推广订单数</p>
              </div>
              <div class="right r-li-r">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-tongji"></use>
                </svg>
              </div>
            </div>
          </van-tab>
          <van-tab title="累计">
            <div class="left retails-t-li">
              <div class="left r-li-l">
                <span>{{ user.sum_price }}</span>
                <p>推广销售额</p>
              </div>
              <div class="right r-li-r">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-tongji"></use>
                </svg>
              </div>
            </div>
            <div class="right retails-t-li">
              <div class="left r-li-l">
                <span>{{ user.whole_count }}</span>
                <p>推广订单数</p>
              </div>
              <div class="right r-li-r">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-tongji"></use>
                </svg>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>

    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="getShare"
    />

    <!--二维码分享-->
    <van-popup v-model="rwmShow">
      <vue-qr :text="rwmData.url" :margin="10" colorDark="#000" colorLight="#fff" :logoScale="0.3" :size="200"></vue-qr>
      <p class="rmg-gz">推广商品二维码</p>
    </van-popup>

    <!--链接分享-->
    <span class="cp-link" :data-clipboard-text="rwmData.url" @click="copy" ref="cpLink"></span>

    <!--微信分享-->
    <van-overlay :show="wechatShow" @click="wechatShow = false">
      <img src="../../assets/images/share_bg_1.png" class="wechat-share" />
    </van-overlay>

    <!--分享海报-->
    <van-overlay :show="posterShow" @click="posterShow = false">
      <div class="poster">
        <h3 class="title">海报推广</h3>
        <p class="title-subname">请长按图片保存</p>
        <div class="img">
          <img :src="img" width="100%" />
        </div>
      </div>
    </van-overlay>

    <Laod ref="laoding" />
    <Footer />
    <wxShare />
  </div>
</template>

<script>
  import { Tab, Tabs, ShareSheet, Popup, Overlay,Dialog } from 'vant'
  import VueQr from 'vue-qr'

  export default {
    components: {
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [ShareSheet.name]: ShareSheet,
      [Popup.name]: Popup,
      [Overlay.name]: Overlay,
      [Dialog.Component.name]: Dialog.Component,
      VueQr
    },
    name: 'retails',
    data() {
      return {
        show: false,
        active: 0,
        wechatShow: false,
        posterShow: false,
        rwmShow: false,
        user: [],
        showShare: false,
        options: [
          { name: '微信', icon: 'wechat' },
          { name: '复制链接', icon: 'link' },
          { name: '分享海报', icon: 'poster' },
          { name: '二维码', icon: 'qrcode' },
        ],
        rwmData: {
          url: process.env.DOMAIN_NAME+'goods/details?hid='+this.$store.state.hid
        },
        img: "",
        userInfo: this.$store.state
      }
    },
    created() {
      // 判断如果是普通用户并且有升级订单
      if(localStorage.getItem('grade_id') == 4 && localStorage.getItem('upgrade_members_grade_id') != 0){
        Dialog.alert({
          message: '您有未支付的注册、升级订单，请尽快付款！',
        }).then(() => {
          this.$router.push({name: 'orders'})
        })
      }else if(localStorage.getItem('grade_id') == 4){
        Dialog.alert({
          message: '您还未成为VIP会员，无法进行推广！',
        }).then(() => {
          this.$router.push({name: 'details.vue'})
        })
      }
      if(this.userInfo.name != null) {
        this.userInfo.username = this.userInfo.name
      }else if(this.userInfo.nickname != null) {
        this.userInfo.username = this.userInfo.nickname
      }
      this.getData()
      this.getPoster()
    },
    methods: {
      getPoster() {
        this.$api.post('poster/store', { id: 2 }, r=>{
          this.img = r.data.url
        })
      },
      getData() {
        this.$api.get('agency/retail', null, r=>{
          this.user = r.data
          this.show = true
          this.$refs.laoding.loadClose()
        })
      },
      copy() {
        let _this = this;
        let clipboard = new this.clipboard(".cp-link")
        clipboard.on('success', function(e) {
          _this.$toast("复制成功")
          e.clearSelection()
          _this.showShare = false
        })
        clipboard.on('error', function(e) {
          _this.$toast("复制失败")
        })
      },
      getShare(option, index) {
        if(index === 0){
          this.wechatShow = true
          this.showShare = false
        }else if(index === 1){
          this.$refs['cpLink'].click()
        }else if(index === 2){
          this.posterShow = true
          this.showShare = false
        } else if(index === 3){
          this.rwmShow = true;
          this.showShare = false
        }
      }
    }
  }
</script>

<style scoped>
  .retails-w{
    padding:15px;
    background: #ffffff;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .retails-shop{
    background: #ffffff;
    overflow: hidden;
  }
  .retails-shop .retails-s-li{
    width: 50%;
    float: left;
    text-align: center;
    padding:20px 0;
  }
  .retails-shop .retails-s-li span{
    font-size: 30px;
  }
  .retails-shop .retails-s-li p{
    margin: 0;
    color:#646566;
    font-size: 15px;
  }
  .retails-tab{
    background: #ffffff;
    margin-top: 10px;
    overflow: hidden;
    padding: 15px;
  }
  .van-tabs__line{
    background-color: #ED6B0D;
  }
  .retails-tab .retails-t-li{
    background: #F2F3F5;
    border-radius: 5px;
    padding:15px;
    width: 39%;
    margin-top: 15px;
  }
  .retails-tab .retails-t-li .r-li-l p{
    margin: 5px 0 0;
    font-size: 14px;
    color:#646566;
  }
  .retails-tab .retails-t-li .r-li-r{
    font-size: 30px;
    margin-top: 8px;
  }
  .rmg-gz{
    text-align: center;
    margin: 0;
    font-size: 14px;
    padding-bottom: 10px;
  }
  .wechat-share{
    width: 70%;
    float: right;
    margin-top: 3%;
    margin-right: 3%;
  }
  .poster{
    color:#fff;
  }
  .poster .title{
    text-align: center;
    font-size: 15px;
    color:#ECCC92;
    font-weight: normal;
    margin-bottom: 0;
  }
  .poster .title-subname{
    text-align: center;
    font-size: 16px;
  }
  .poster .img{
    padding:0 15%;
  }
  .poster .img img{
    width: 100%;
    border:4px solid #fff;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/views/retails/index.vue